import { Box } from "@mui/material"
import { MainContainer } from "../../components/MainContainerComp"
import { DownloadableForms } from "./DownloadableForms"
import { FormsGroups } from "./DownlodableFormsModel"
import { containerStyle } from "./styled"

export const DownloadableFormsRoute = () => {
  return (
    <MainContainer>
      <Box sx={containerStyle}>
        {FormsGroups.map((item) => <DownloadableForms key={item.title} {...item} />)}
      </Box>
    </MainContainer>
  )
}